var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsAuDelivery = function SvgNnIconFlagsAuDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-AU-delivery_svg__Lager_30",
    "data-name": "Lager 30",
    viewBox: "0 0 50.47 33.82"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-AU-delivery_svg__cls-3{fill:#fff}.nn-icon-flags-AU-delivery_svg__cls-4{fill:#e60026}"))), /*#__PURE__*/React.createElement("path", {
    d: "M.12.13h50.22V33.7H.12z",
    style: {
      fill: "#0037a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.24 10.06h5v6.86h-5z",
    className: "nn-icon-flags-AU-delivery_svg__cls-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.25 16.9h2.73l9.49-6.78-2.73-1.96-9.49 6.79z",
    className: "nn-icon-flags-AU-delivery_svg__cls-3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2.07 16.9 8.15-5.82H8.39L.25 16.9z",
    className: "nn-icon-flags-AU-delivery_svg__cls-4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.9h2.73v-1.95l-9.48-6.78-2.73 1.95z",
    className: "nn-icon-flags-AU-delivery_svg__cls-3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.23 16.9v-1.3l-6.32-4.52h-1.82z",
    className: "nn-icon-flags-AU-delivery_svg__cls-4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.23.25H22.5l-9.48 6.79 2.73 1.95 9.48-6.78z",
    className: "nn-icon-flags-AU-delivery_svg__cls-3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m23.41.25-8.14 5.83h1.82L25.23.25z",
    className: "nn-icon-flags-AU-delivery_svg__cls-4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98.25H.25V2.2l9.48 6.79 2.73-1.96z",
    className: "nn-icon-flags-AU-delivery_svg__cls-3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M.25 6.08h10.17v5H.25z",
    className: "nn-icon-flags-AU-delivery_svg__cls-3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.24.26h5v6.82h-5z",
    className: "nn-icon-flags-AU-delivery_svg__cls-3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M.25.25v1.3l6.32 4.52h1.82z",
    className: "nn-icon-flags-AU-delivery_svg__cls-4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.05 6.08h10.18v5H15.05z",
    className: "nn-icon-flags-AU-delivery_svg__cls-3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.24 7.08V.26h-3v6.82H.25v3h10.99v6.83h3v-6.83h10.99v-3z",
    className: "nn-icon-flags-AU-delivery_svg__cls-4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AU-delivery_svg__Star7",
    d: "m12.73 20.24.97 2.99 2.94-1.11-1.74 2.62 2.71 1.61-3.14.27.43 3.12-2.17-2.28-2.16 2.28.43-3.12-3.14-.27 2.71-1.61-1.74-2.62 2.94 1.11z",
    className: "nn-icon-flags-AU-delivery_svg__cls-3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AU-delivery_svg__Star7-2",
    d: "m38.2 25.63.45 1.43 1.4-.53-.82 1.25 1.29.76-1.5.13.21 1.49-1.03-1.09-1.04 1.09.21-1.49-1.49-.13 1.28-.76-.83-1.25 1.41.53z",
    className: "nn-icon-flags-AU-delivery_svg__cls-3",
    "data-name": "Star7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AU-delivery_svg__Star7-3",
    d: "m29.86 12.44.46 1.43 1.41-.53-.83 1.25 1.29.76-1.5.13.21 1.49-1.04-1.09-1.03 1.09.21-1.49-1.49-.13 1.28-.76-.83-1.25 1.41.53z",
    className: "nn-icon-flags-AU-delivery_svg__cls-3",
    "data-name": "Star7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AU-delivery_svg__Star7-4",
    d: "m38.2 3.42.45 1.43 1.4-.53-.82 1.24 1.29.77-1.5.13.21 1.48-1.03-1.08-1.04 1.08.21-1.48-1.49-.13 1.28-.77-.83-1.24 1.41.53z",
    className: "nn-icon-flags-AU-delivery_svg__cls-3",
    "data-name": "Star7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AU-delivery_svg__Star7-5",
    d: "m45.6 10.22.46 1.43 1.4-.53-.83 1.25 1.29.76-1.49.13.2 1.49-1.03-1.09-1.03 1.09.2-1.49-1.49-.13 1.29-.76-.83-1.25 1.4.53z",
    className: "nn-icon-flags-AU-delivery_svg__cls-3",
    "data-name": "Star7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-AU-delivery_svg__Star5",
    d: "m41.53 16.91.36.89.96.06-.74.62.23.94-.81-.51-.82.51.23-.94-.74-.62.96-.06z",
    className: "nn-icon-flags-AU-delivery_svg__cls-3"
  })));
};
export default SvgNnIconFlagsAuDelivery;